import { Alert, Box, Snackbar } from "@mui/material";
import { useState } from "react";
import ErrorIcon from "@mui/icons-material/Error";

export const InputsErrMsg = ({ open, setOpen, message, ckColor = "#d32f2f", bgcolor = "#fcd2cf", hideDrtn = 3000 }) => {
    const [alert] = useState({ vertical: "bottom", horizontal: "center" });
    const { vertical, horizontal } = alert;
    return (
        <Snackbar key={vertical + horizontal} anchorOrigin={{ vertical, horizontal }} autoHideDuration={hideDrtn} open={open} onClose={() => setOpen(false)}>
            <Alert
                icon={<ErrorIcon sx={{ color: ckColor }} />}
                sx={{
                    bgcolor: bgcolor,
                    color: "#69717A",
                    display: "flex",
                    alignItems: "center",
                    borderRadius: 2,
                    p: "4px",
                    ".css-1ytlwq5-MuiAlert-icon": { marginRight: "4px" },
                }}
                className="shadow-sm"
            >
                <Box component="b" sx={{ fontSize: { xs: 12, md: 14 } }}>
                    {message}
                </Box>
            </Alert>
        </Snackbar>
    );
};
